import { useLingui } from '@lingui/react/macro'
import { useLocation } from 'wouter'

import { AddButton } from '@/components/ui/IconButton'

export function AddPromotionButton() {
  const { t } = useLingui()
  const [, navigate] = useLocation()

  return (
    <AddButton
      aria-label={t({
        message: `Add Promotion`
      })}
      onClick={() => navigate('/create-promotion')}
    />
  )
}
